import React, { useEffect, useState } from 'react';
import { CommonUtil } from '../../../utils/CommonUtil';
import { NetworkManager } from '../../../Components/NetworkManager';
import TaskNewRelease from './TaskNewRelease';
import ToastManager from '../../../Components/ToastManager';

const ProcessNewRelease = ({onClose, onPrev, processes, docTypeId, getAllProcesses, multiSeqId}: any) => {
  const selectedDocTypeId = localStorage.getItem("selectedDocTypeId");
  const saasOrgId = CommonUtil.getSaasOrgId();
  const [tasks, setTasks] = useState<any>([]);
  const [selectedProcess, setSelectedProcess] = useState<any>(null);
  const [completedTasks, setCompletedTasks] = useState<any>(0);
  
  let onLoginError = (err: any) => {
    console.log(err);
  };

  useEffect(() => {
    if (processes?.length > 0) {
      const firstPendingProcess = processes.find((p: any) => p.pendingTasks !== 0);
      setSelectedProcess(firstPendingProcess || processes[0]);
    }
  }, [processes]);
  
  useEffect(()=>{
    if(selectedProcess !== null){
      getDocInspection();
    }
  },[selectedProcess])

  const getDocInspection = () => {
    const orgUrl = `api/dashboard/inspection-event-details/?orgId=${saasOrgId}&docId=${CommonUtil.getInterchangeDocumentId()}${selectedDocTypeId ? "&dependentDpcTypeId="+selectedDocTypeId : ""}`;
    NetworkManager.sendJsonRequest(orgUrl, "", "", "GET", true, onDocInspection, onLoginError);
  };
    
  const onDocInspection = (dataObj: any) => {
    const docData = JSON.parse(dataObj);
    if (docData && !docData.errorMessage) {
      multiSeqId(docData?.[0]?.multiSequence);
      getTasks(docData);
    }else{
      ToastManager.showToast(docData.errorMessage, "Error");
    }
  }
  
  const getTasks = (docData: any) => {
    const orgId = `orgId=${saasOrgId}`;
    const documentId = `documentId=${processes[0]?.documentId}`;
    const docTypeid = `dependentDocTypeId=${docTypeId}`;
    const seqId = `seqId=${docData?.[0]?.multiSequence === null ? 0 : docData?.[0]?.multiSequence}`;
    const processId = `processId=${selectedProcess?.processId}`;
    const isInterchangeEnabled = `isInterchangeEnabled=${docTypeId !== null ? true : false}`
    const orgUrl = `api/inspection/v2/document-inspection-process/tasks?${orgId}&${documentId}&${docTypeid}&${processId}&${isInterchangeEnabled}&${seqId}`;
    NetworkManager.sendJsonRequest(orgUrl, "", "", "GET", true, (dataObj: any) => {
      if (dataObj) {
        var restData = JSON.parse(dataObj);
        if (restData){
          const transformedData = transformTyreData(restData);
          setTasks(transformedData);
        }
      }
    }, onLoginError);
  };

  const transformTyreData = (data: any) => {
    const newData = JSON.parse(JSON.stringify(data));
    
    newData.taskGroups?.forEach((taskGroup: any) => {
        taskGroup.tasks?.forEach((task: any) => {
            if (task.tyreBrands) {
              task.tyreBrands = task.tyreBrands.map((brand: string) => ({
                  label: brand,
                  value: brand
              }));
            }
            if (task.tyreSizes) {
              task.tyreSizes = task.tyreSizes.map((size: string) => ({
                  label: size,
                  value: size
              }));
            }
            if (task.tyreDepths) {
              task.tyreDepths = task.tyreDepths.map((depth: string) => ({
                  label: depth,
                  value: depth
              }));
            }
        });
    });
    
    return newData;
};
  const selectedItem = {
    borderLeft: "solid black 6px",
    fontWeight: 700,
    color: "#344054",
  };

  return (
    <div className=" col-12">
      <div className='d-flex'>
        <div className="col-3 mb-5">
          <ul className="list-group rounded-0 border-top-0 border-end-0">
            {processes?.map((item: any, index: any)=>(
              <li key={index} role="button" className="list-group-item py-2" 
                onClick={()=>setSelectedProcess(item)}
                style={selectedProcess?.processId === item?.processId ? selectedItem : {}}
                >
                <div className='d-flex justify-content-between align-items-center'>
                  <div>
                    <div>{item?.processName}</div>
                    <small className="text-muted my-0" style={{marginLeft: "2px"}} >{item?.totalTasks} Tasks</small>  
                  </div>
                  <div>{item?.pendingTasks === 0 && <i className="fa-solid fa-circle-check text-success"></i>}</div>
                </div>
              </li>
            ))}
          </ul>
        </div> 
        <div className='col-9 border-start'>
          <div className='d-flex justify-content-evenly border-bottom py-3' style={{backgroundColor: "#D4DFE8"}}>
            <div>Total: <b>{selectedProcess?.totalTasks || 0}</b></div>
            <div>Completed: <b>{completedTasks || 0}</b></div>
            <div>Pending: <b>{Number(selectedProcess?.totalTasks - completedTasks) || 0}</b></div>
          </div>
          <div style={{height: `${window.innerHeight - 110}px`}}>
            <div className='pt-2'>
              {tasks?.taskGroups?.length > 0 && 
                <TaskNewRelease tasks={tasks} onClose={onClose}
                  data={{processId: selectedProcess?.processId, docTypeId: docTypeId, documentId: processes[0]?.documentId, isInterchangeEnabled: docTypeId !== null ? true : false,   }} 
                  onCompletionUpdate={(count: any)=>setCompletedTasks(count)} 
                  onProcessComplete={() => {
                      const currentIndex = processes.findIndex((p: any) => p.processId === selectedProcess?.processId);
                      const nextProcess = processes[currentIndex + 1];
                      if (nextProcess) {
                        setSelectedProcess(nextProcess);
                        // setCompletedTasks(0); // reset task count
                      } else {
                        console.log("All processes completed");
                      }
                    }}
                  getAllProcesses={getAllProcesses}
                  isNoPendingProcess={processes?.every((p: any) => p.pendingTasks === 0)}
                  />}
            </div>
          </div>
        </div>
      </div>
      <div className="d-flex justify-content-between border-top p-3 d-none">
          <div>
            <button className="btn btn-outline-secondary px-4" onClick={()=>onPrev(1)}>Back</button>
          </div>
          <div className="d-flex justify-content-end">
            <button className="btn btn-outline-secondary px-4 me-2">Close</button>
            <button className="btn btn-primary px-4">Save and Proceed</button>
          </div>
      </div> 
    </div>
  );
};

export default ProcessNewRelease;